import { createSelector, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

const DEFAULT_EMPTY_OBJECT = {};

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'suggestedFilters',
    initialState: {
        filters: [],
    },
}).extend({
    selectors: (duck) => ({
        getSuggestedFilters: new DuckSelector((selectors) => (state) => {
            const localState = selectors.getDuckState(state);
            return localState.filters;
        }),
        getFirstSuggestion: new DuckSelector((selectors) => createSelector(
            selectors.getDuckState,
            (localState) => localState.filters?.[0] || DEFAULT_EMPTY_OBJECT,
        )),
    }),
});
